import { IUploadDialog } from "../popups/upload-dialog";

interface ICurrentUpload {
	id: string;
	done: number;
	total: number;
}

const currentUploads: ICurrentUpload[] = [];
export function createUploadIndicator(
	totalUploads: number,
	progressEl?: HTMLElement,
	onFileUploaded?: () => void,
	forceUpdateOfFiles: boolean = false,
): IUploadDialog {
	const id = Math.random().toString(16);

	currentUploads.push({
		id,
		done: 0,
		total: totalUploads,
	});

	const close = (): void => {};

	const progressMessage = progressEl ? progressEl.dataset.text || "" : "";
	const updateProgress = (done: number) => {
		if (!progressEl) return;

		const uploadSession = currentUploads.find((x) => x.id === id);
		if (!uploadSession) return;
		uploadSession.done = done;

		const totalDone = currentUploads.reduce((sum, x) => sum + x.done, 0);
		const totalTodo = currentUploads.reduce((sum, x) => sum + x.total, 0);
		if (totalDone >= totalTodo) {
			progressEl.innerText = "";
			currentUploads.length = 0;
			return;
		}

		if (onFileUploaded && (getRemaining() > 10 || forceUpdateOfFiles)) {
			onFileUploaded();
		}

		progressEl.innerText = progressMessage.replace("{0}", totalDone + "").replace("{1}", totalTodo + "");
	};
	const getRemaining = (): number => {
		const totalDone = currentUploads.reduce((sum, x) => sum + x.done, 0);
		const totalTodo = currentUploads.reduce((sum, x) => sum + x.total, 0);
		return totalTodo - totalDone;
	};
	return {
		id: id,
		setTotalUploads: (id: string, newTotal: number) => {
			const currentUpload = currentUploads.find((x) => x.id === id);
			if (!currentUpload) return;
			currentUpload.total = newTotal;
		},
		close: close,
		updateProgress,
		getRemaining,
	} as IUploadDialog;
}
